import { MockedProvider } from "@apollo/client/testing";
import React, { useEffect } from "react";
import { FIND_MISSION_AUDIT_LOGS } from "../../graphql/core";
import type { Meta, StoryObj } from "@storybook/react";
import { currentLang } from "../../atoms/i18n";
import { RecoilRoot } from "recoil";
import MissionLogsScreen from "../../screens/user/MissionLogs";
import { defaultApolloClientCache } from "../../configs/graphql.config";
import { buildAuditLogPageResult } from "../factories";

const mocks = [
    {
        variableMatcher: () => true,
        maxUsageCount: Number.POSITIVE_INFINITY,
        request: {
            query: FIND_MISSION_AUDIT_LOGS,
        },
        error: undefined,
        newData: (variables: { offset: number }) => {
            const offset = variables.offset;
            return {
                data: {
                    findMissionAuditLogs: buildAuditLogPageResult(100, offset),
                },
            };
        },
    },
];

function StoryComponent() {
    const missionId = `test-mission-id`;

    useEffect(() => {}, []);

    return (
        <RecoilRoot
            initializeState={(snap) => {
                snap.set(currentLang, "fr");
            }}
        >
            <MockedProvider mocks={mocks} cache={defaultApolloClientCache}>
                {/* @ts-expect-error Stack Component need a complex navigation handler */}
                <MissionLogsScreen route={{ params: { missionId } }} />
            </MockedProvider>
        </RecoilRoot>
    );
}

const meta = {
    title: "Screens/MissionLogs",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
    args: {},
};
